import { actionTypes } from '../Actions/notify.action'

const INITIAL_STATE = {
    open: false,
    horizontal: 'center',
    vertical: 'top',
    class: 'info',
    time: 3000,
    msg: 'Vinhasoft Sistemas',
    errorDetail: {}
  };
  
  // eslint-disable-next-line
  export default (state = INITIAL_STATE, { type, payLoad }) => {
    switch (type) {
      case actionTypes.CHAGE:
        return { ...state, ...payLoad };
      default:
        return state;
    }
  };